/** "purchase_order_number" -> "Purchase order number". */
export function humanize(key: string): string {
    return key.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
}

/** A warehouse value as the page shows it: "—" for nothing, Yes/No for booleans, lists joined. */
export function show(value: unknown): string {
    if (value === null || value === undefined || value === "") return "—";
    if (typeof value === "boolean") return value ? "Yes" : "No";
    if (Array.isArray(value)) return value.length ? value.map(show).join(", ") : "—";
    if (typeof value === "object") {
        const parts = Object.entries(value as Record<string, unknown>).map(([k, v]) => `${humanize(k)}: ${show(v)}`);
        return parts.length ? parts.join("; ") : "—";
    }
    return String(value);
}
